import { settingsService } from "../../services/settings.service";
import { Produkt } from "../types/organizacje";
import { settingsConst } from "../types/settings";

export const settingsActions = {
  dajDostepneProdukty,
};

function dajDostepneProdukty() {
  return (dispatch: Function) => {
    dispatch(request());
    return settingsService.dajDostepneProdukty().then(
      (result: Produkt[]) => {
        dispatch(success(result));
      },
      (error) => {
        setError(error);
      }
    );
  };

  function request() {
    return { type: settingsConst.DAJ_DOSTEPNE_PRODUKTY_REQUEST };
  }
  function success(res: Produkt[]) {
    return { type: settingsConst.DAJ_DOSTEPNE_PRODUKTY_SUCCESS, produkty: res };
  }
  function setError(error: string) {
    return {
      type: settingsConst.DAJ_DOSTEPNE_PRODUKTY_FAILURE,
      error: error,
    };
  }
}
